import { createContext } from "react"

type ModalContextType = {
  handleClose?: () => void
}

const ModalContext = createContext<ModalContextType>({})

export default ModalContext
